import { Component, Input, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';
import { TimeStampResponseModel } from 'projects/Administration/src/app/business-entities/time-stamp-report-model';

@Component({
  selector: 'app-time-stamp-details-grid',
  templateUrl: './time-stamp-details-grid.component.html',
  styleUrls: ['./time-stamp-details-grid.component.css']
})
export class TimeStampDetailsGridComponent implements OnInit {

  @Input() timeStampDetails: TimeStampResponseModel[] = [];
  dateTimeFormat: string = 'dd.MM.yyyy, HH:mm:ss';

  constructor(private datePipe: DatePipe) { }

  ngOnInit(): void {
  }

  getFormattedDate(dateValue: any): string {
    if (!dateValue) {
      return '';
    }
    const date = new Date(dateValue);
    if (isNaN(date.getTime())) {
      return '';
    }
    return this.datePipe.transform(dateValue, this.dateTimeFormat) || '';
  }
}